"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileConnectorV2 = void 0;
const messagesV2_1 = require("./messagesV2");
const mobileConnector_1 = require("./mobileConnector");
class MobileConnectorV2 extends mobileConnector_1.MobileConnector {
    constructor(deviceConnector, mobileHandler, messages = messagesV2_1.MESSAGES) {
        super(deviceConnector, mobileHandler, messages);
        this.fetch = (data) => this.mobileCommunicator.request(this.messages.TYPE_FETCH.key, data, this.messages.TYPE_FETCH.timeout);
        this.requestNativeLoader = (data) => this.mobileCommunicator.request(this.messages.TYPE_NATIVE_LOADER.key, data, this.messages.TYPE_NATIVE_LOADER.timeout);
    }
}
exports.MobileConnectorV2 = MobileConnectorV2;
//# sourceMappingURL=mobileConnectorV2.js.map